import React, { useState, useEffect } from "react";
import noImage from "../../../../assets/images/noImage.png";
import ProductTable from "../../../../Components/BoltTable/BoltTable";
import { PiPackageLight } from "react-icons/pi";
import { useSelector } from "react-redux";
import { fetchOnlyProducts } from "../../../../services/product.service";
import Tooltips from "../../../../Components/Tooltip/Tooltip";
import { BsPlus } from "react-icons/bs";
import { useTranslation } from "react-i18next";

export default function AvailableListView(props) {
  const { t } = useTranslation("inventory");
  const { handlescrollpackage, formData } = props;
  const user = useSelector((state) => state.user);
  const [productData, setproductData] = useState([]);

  const columns = [
    {
      id: 0,
      label: "#",
      render: (row) => <>{row?.id ?? "-"}</>,
      width: "200px",
    },
    {
      id: 1,
      label: t("stockReceived.image"),
      render: (row) => (
        <img
          src={ImageUrl(row)}
          onError={(e) => {
            e.target.src = noImage;
          }}
          loading="lazy"
        />
      ),
      fixed: "left",
    },
    {
      id: 2,
      label: t("stockReceived.name"),
      render: (row) => <>{row.name ?? "-"}</>,
      width: "200px",
    },
    {
      id: 3,
      label: t("stockReceived.sku"),
      render: (row) => <>{row.code ?? "-"}</>,
      width: "200px",
    },
    {
      id: 4,
      label: t("stockReceived.dimensionsLWH"),
      render: (row) => (
        <>
          <div
            className="product_dimension_parent_wrapper"
            style={{ maxWidth: "200px" }}
          >
            <div>
              {row?.length ?? "0"}*{row?.width ?? "0"}*{row?.height ?? "0"} (
              {row?.dimension_unit?.toUpperCase() ?? "N/A"})
            </div>
            <div className="product__notification_circle_wrapper">
              <PiPackageLight size={10} />
              {row?.package_details &&
                Object?.values(row?.package_details)?.length > 0 && (
                  <div className="product__notification_circle">
                    {Object.values(row?.package_details)?.length}
                  </div>
                )}
            </div>
          </div>
        </>
      ),
      width: "200px",
    },
    {
      id: 5,
      label: t("stockReceived.weight"),
      render: (row) => (
        <>
          {row?.weight ?? "0"} {row?.weight_unit}
        </>
      ),
      width: "200px",
    },
    {
      id: 6,
      label: t("stockReceived.quantity"),
      render: (row) => (
        <>
          {row?.product_warehouse?.reduce(
            (total, warehouse) => total + parseInt(warehouse.quantity, 10) || 0,
            0
          )}
        </>
      ),
      width: "200px",
    },
    // {
    //   id: 8,
    //   label: "Actions",
    //   render: (row) => (
    //     <>
    //       {" "}
    //       <div className="table_action__wrap">
    //         <Tooltip
    //           title={
    //             StepCheck["Warehouses"] ? "Click To Add" : "Select Warehouse"
    //           }
    //         >
    //           <div
    //             className="table_action__btn"
    //             onClick={() => handlescrollpackage(row)}
    //           >
    //             <BsPlus size={10} />
    //             Add
    //           </div>
    //         </Tooltip>
    //       </div>
    //     </>
    //   ),
    //   width: "200px",
    //   fixed: "right",
    // },
  ];

  const warehouses = user?.user_approved_warehouses;
  const insertIndex = columns.length;
  warehouses?.forEach((warehouse, index) => {
    columns.splice(insertIndex, 0, {
      id: 1000 + index,
      label: warehouse?.warehouse?.name,
      render: (row) => {
        const matchedWarehouse = row?.product_warehouse?.find(
          (item) => item?.warehouse_id == warehouse?.warehouse_id
        );

        return (
          <>
            {matchedWarehouse && (
              <>
                {
                  <div
                    className="product__textalign_center"
                    style={{
                      fontWeight:
                        matchedWarehouse?.warehouse_id == formData?.warehouse_id
                          ? "bold"
                          : "",
                    }}
                  >
                    {matchedWarehouse?.quantity ?? "-"}
                  </div>
                }
              </>
            )}
          </>
        );
      },
      width: "250px",
    });
  });

  const ImageUrl = (row) => {
    const url =
      row?.media.find((media) => media.is_primary === "true")?.file ||
      row?.media[0]?.file;
    return url || noImage;
  };

  const getAllProducts = async (page, perPage, filter) => {
    const response = await fetchOnlyProducts(page, perPage, filter);
    if (!response.error) {
      setproductData(response?.data?.result);
    } else {
    }
  };

  return (
    <>
      <div className="custom__table_size1 actionbtn__needtobe_fixwidth">
        <ProductTable
          tableId="availableListViewTableforWarehouse"
          message={t("stockReceived.noProductsAvailableToDisplay")}
          searchPlaceHolder={t("stockReceived.searchProducts")}
          getAllData={getAllProducts}
          data={productData}
          columns={columns}
          handleRowClick={handlescrollpackage}
          isRowClick={
            formData?.warehouse_id
              ? t("stockReceived.clickToAdd")
              : t("stockReceived.selectWarehouse")
          }
        />
      </div>
    </>
  );
}
